<template>
  <section>
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('TABLE', 2) }) | formatTitle"></vue-headful>
    <table-list></table-list>

    <router-view class="tables__route"></router-view>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import TableList from './TableList'

export default {
  name: 'tables',
  components: { TableList }
}
</script>
